// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1rdK0","title":"Images45_title__1hw4M","images":"Images45_images__O0KqN"};